import { useState, useEffect } from 'react';
import ReactJson from 'react-json-view';
import './fieldMap.less';
import { Form, Button, Select, message, Input, Table, Popconfirm, Tooltip, Badge, Switch } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { SActionBtn, SBack, STableActions, SFuncModal } from 'shj-components'
import { verifyJSON } from './addOrEdit';
import { debounce } from 'lodash-es';
import { updateMapping,businessMattersFieldMappingList, commonConvertGetJsonAllPath } from '@/services/integrationConfig'
const Option = Select.Option;
export function fieldMapFn({ fn, ...rest }: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `字段映射`,
    width: 1600,
    vanish: true,
    content: <FieldMapDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

export const FieldMapDom = ({ onClose, fn, ...rest }: any) => {
  const [form] = Form.useForm();
  const [footerLoading, setFooterLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [businessJsonPath, setbusinessJsonPath] = useState<string[]>([]); //业务字段JSON全路径
  const [financeJsonPath, setfinanceJsonPath] = useState<string[]>([]); //财务字段JSON全路径

  const columns = [
    {
      title: '业务字段',
      dataIndex: 'businessField',
      editable: true,
      width: 280,
      ellipsis: true,
      render: (text: string, record: any, index: number) => (
        <Tooltip title={text}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            value={text}
            style={{ width: '100%' }}
            onChange={(v) => {
              let d = [...data];
              d[index].businessField = v;
              setData(d);
            }}
          >
            {businessJsonPath.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </Tooltip>
      ),
    },
    {
      title: '业务描述',
      dataIndex: 'businessFieldDesc',
      editable: true,
      ellipsis: true,
      render: (text: string, record: any, index: number) => (
        <Tooltip title={text}>
          <Input
            value={text}
            style={{ width: '100%' }}
            onChange={(v) => {
              let d = [...data];
              d[index].businessFieldDesc = v.target.value;
              setData(d);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: '财务字段',
      dataIndex: 'financeField',
      editable: true,
      width: 280,
      ellipsis: true,
      render: (text: string, record: any, index: number) => (
        <Tooltip title={text}>
          <Select
            allowClear
            showSearch
            optionFilterProp="children"
            value={text}
            style={{ width: '100%' }}
            onChange={(v) => {
              let d = [...data];
              d[index].financeField = v;
              setData(d);
            }}
          >
            {financeJsonPath.map((item: string, index: number) => {
              return (
                <Option key={index} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </Tooltip>
      ),
    },
    {
      title: 'kd主键',
      width: 65,
      dataIndex: 'kdPrimaryKey',
      render: (text: string, record: any, index: number) => (
        <Switch
          checked={!!text}
          size="small"
          onChange={(v) => {
            let flag = data.some((e) => e.kdPrimaryKey);
            if (flag && v) {
              message.error('请关闭前一个主键');
              return;
            }
            let d = [...data];
            d[index].kdPrimaryKey = v;
            setData(d);
            save(record, index);
          }}
        />
      ),
    },
    {
      title: '财务描述',
      dataIndex: 'financeFieldDesc',
      editable: true,
      ellipsis: true,
      render: (text: string, record: any, index: number) => (
        <Tooltip title={text}>
          <Input
            value={text}
            style={{ width: '100%' }}
            onChange={(v) => {
              let d = [...data];
              d[index].financeFieldDesc = v.target.value;
              setData(d);
            }}
          />
        </Tooltip>
      ),
    },
    {
      title: '操作',
      dataIndex: 'address',
      width: 120,
      fixed: 'right',
      render: (_: any, record: any, index: number) => {
        return (
          <div>
            <STableActions>
              <Badge
                count={
                  record?.id ? (
                    <CheckCircleOutlined style={{ color: '#52C41A' }} />
                  ) : (
                    <ExclamationCircleOutlined style={{ color: '#FF603B' }} />
                  )
                }
              >
                <SActionBtn
                  onClick={() => {
                    save(record, index);
                  }}
                  disabled={footerLoading}
                >
                  保存
                </SActionBtn>
              </Badge>
              <SActionBtn title="是否删除？" danger confirm
                onClick={() => onDelRow(record, index)} okText="是" cancelText="否" disabled={footerLoading}>
                删除
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  ];
  const onCommit = (record: any, index: number) => {
    if (!record?.businessField && !record?.businessFieldDesc && !record?.financeField && !record?.financeFieldDesc) {
      message.warning('请填写数据');
      return;
    }
    setFooterLoading(true);
    let params = {
      busOfBillId: rest.id,
      businessMattersId: rest.busMattersId,
      ...record,
    };
    if (record?.id) {
      params.id = record?.id;
    }
    updateMapping(params).then((resp: any) => {
        message.success(resp?.message || '操作成功');
        setFooterLoading(false);
        if (!record?.id) {
          let newData = [...data];
          newData[index].id = resp?.id;
          setData(newData);
        }
      })
      .catch(() => {
        setFooterLoading(false);
      });
  };
  const save = debounce(onCommit, 1000, {
    leading: true,
    trailing: false,
  });
  const onAddRow = () => {
    const newData = [...data];
    const obj = {
      businessField: '',
      businessFieldDesc: '',
      financeField: '',
      financeFieldDesc: '',
    };
    newData.push(obj);
    setData(newData);
  };
  const onDelRow = (record: any, index: number) => {
    if (!record.id) {
      let d = [...data];
      d.splice(index, 1);
      setData(d);
      return;
    }
    setFooterLoading(true);
    let params = {
      busOfBillId: rest.id,
      businessMattersId: rest.busMattersId,
      isDeleted: true,
      id: record.id,
    };
    updateMapping(params).then((resp: any) => {
        message.success(resp?.message || '操作成功');
        setFooterLoading(false);
        // initFn();
        let d = [...data];
        d.splice(index, 1);
        setData(d);
      })
      .catch(() => {
        setFooterLoading(false);
      });
  };
  useEffect(() => {
    if (rest?.id) {
      initFn();
    }
  }, [rest?.id]);
  useEffect(() => {
    getJsonAllPath(rest?.financeJson, 'finance');
  }, [rest?.financeJson]);
  const initFn = () => {
    businessMattersFieldMappingList({ busOfBillId: rest.id }).then((resp: any) => {
        let arr = resp || [];
        setData(arr);
        getJsonAllPath(rest?.businessParamJson, 'business', arr);
      });
  };
  const getJsonAllPath = (jsonStr: string, type = 'business', data = []) => {
    if (!verifyJSON(jsonStr)) return;
    commonConvertGetJsonAllPath(JSON.parse(jsonStr)).then((resp: any) => {
        const path = resp?.paths || [];
        if (type === 'business') {
          setbusinessJsonPath(path);
          fillData(path, data);
        } else {
          setfinanceJsonPath(path);
        }
      });
  };
  const fillData = (JsonAllPath = [], d = []) => {
    const newData: any = [...d];
    let keyArr = newData.map((e) => e?.businessField);
    JsonAllPath.map((e) => {
      if (!keyArr.includes(e)) {
        const obj = {
          businessField: e,
          businessFieldDesc: '',
          financeField: '',
          financeFieldDesc: '',
        };
        newData.push(obj);
      }
    });
    setData(newData);
  };
  const summaryRender = () => {
    return (
      <tr>
        <td colSpan={5} style={{ border: 'none' }}>
          <div className="fieldMapAddRowBtn">
            <Button type="primary" shape="circle" icon={<PlusOutlined />} onClick={onAddRow} />
          </div>
        </td>
      </tr>
    );
  };
  return (
    <div>
      <Form form={form} component={false} style={{ padding: 15 }}>
        <div className="FieldMapBox">
          <div className="FieldMapBoxRect">
            <div className="FieldMapBoxRectTitle">业务参数</div>
            <div className="FieldMapBoxRectJson">
              <ReactJson
                src={JSON.parse(rest?.businessParamJson)}
                name={false}
                displayDataTypes={false}
                displayObjectSize={false}
              />
            </div>
          </div>
          <div className="FieldMapBoxTable">
            <Table
              scroll={{ x: 50 }}
              columns={columns}
              dataSource={data}
              size="small"
              bordered={true}
              pagination={false}
              summary={summaryRender}
            />
          </div>
          <div className="FieldMapBoxRect">
            <div className="FieldMapBoxRectTitle">财务结构化参数</div>
            <div className="FieldMapBoxRectJson">
              <ReactJson
                src={JSON.parse(rest?.financeJson)}
                name={false}
                displayDataTypes={false}
                displayObjectSize={false}
              />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
